function Settings() {
  return <div>There is not much settings yet..</div>;
}

export default Settings;
